import { createRefPath, createRefPath_client, createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import _ from "lodash";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { PapsContext } from "../PapsContext";
import { _showAppLogs, LogContext } from "../LogContext";
import { updateFirestoreData } from "global/firestoreData/updates/dataUpdates";
import { AppUserContext } from "../AppUserContext";
import { ParentContext } from "../ParentContext";
import { updateLinkHelpers } from "global/firestoreData/updates/subUpdates/fsUpdate_dataLInks";

export const useFirestoreUpdate = ({ dataUpdateType }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { appSettings_state, app_state, appUser_state, currentSettings_state, paps_state, eventInfo_state } = states
  const { appSettings_fns, page_fns } = fns ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataRestrictions, appDataSource } = aps_global ?? {}
  const { mainDb, mainStorage } = app_state ?? {}
  const { appDataDocuments } = eventInfo_state ?? {}

  const { appUser, appUsers } = appUser_state ?? {}

  // logContext
  const logContext = useContext(LogContext)
  const { log_handlers } = logContext ?? {}

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const updateFsData = useCallback(
    async ({
      vit,
      data_modified,
      data_original,
      selectedDataItems,
      staticViewKeys,
      swipedItem,
      appDataDocs,
      callback
    }) => {
      const cb = (res) => {
        callback(res)
      }
      const { autoUpdateCollectionRelationships } = appDataSource ?? {}
      const opts = {}
      const ufProps = {
        appDataDocs,
        appDataSource,
        autoUpdateCollectionRelationships,
        data_original,
        dataUpdateType: dataUpdateType,
        relatedDocsToUpdate: null,
        id: data_modified?.id || null,
        itemData: data_modified,
        mainStorage,
        modifyType: dataUpdateType,
        selectedDataItems: selectedDataItems,
        staticViewKeys,
        swipedItem,
        vit: vit,
      }

      const _appDataDocuments = _.cloneDeep(appDataDocuments)
      const appDataDocument = _appDataDocuments?.[vit]
      const appDataDoc = appDataDocument?.[data_modified?._itemKey]

      const relatedDocsToUpdate = updateLinkHelpers.getDocsToUpdate({
        vit: vit,
        prevItem: appDataDoc,
        nextItem: data_modified,
        appDatas: _appDataDocuments
      })

      ufProps.relatedDocsToUpdate = relatedDocsToUpdate

      console.group('useFirestoreUpdate')
      console.log('ufProps', ufProps)
      console.groupEnd()

      return updateFirestoreData(cb, paps_state, ufProps, page_fns, appUser, dataRestrictions, opts, database_fns, appSettings_fns, mainDb, fn_cls, mainStorage)
    },
    []
  );

  return {
    updateFsData,
  };
};
